import React from "react";
import ListBoxItem from "../../../../../components/molecules/ListBoxItem/ListBoxItem";
import { numberToStingWithSpaces } from "../../../../../utils/numberDisplayer";
import "./spendingListView.scss";
import EmptyListIcon from "../../../../../components/atoms/EmptyListIcon/EmptyListIcon";
import Table from "../../../../../components/molecules/Table/Table";
import StatusBox from "../../../../../components/atoms/StatusBox/StatusBox";
import { IconType } from "../../../../../assets/JWayIcons";
import { limitString } from "../../../../../utils/stringUtils";

export interface ItemSpending {
  id: string;
  title?: string;
  userFirstName?: string 
  userLastName?: string 
  userFullNameRenderer?: () => React.ReactNode;
  projectNameRenderer?: () => React.ReactNode;
  date?: string;
  createdDate?: string;
  grossAmmount?: number;
  status?: string;
  pinColor?: string;
  withPin?: boolean;
  isChecked?: boolean;
  colorStatus?: {
    backgroundColor?: string;
    color?: string;
    iconType?: IconType;
  };
  projectName?: string;
  category?: string;
  onCheck?: () => void;
  onClick?: () => void;
}

export interface SpendingListViewProps {
  spendingList: ItemSpending[];
  emptyMessage?: string;
  isCheckMode?: boolean;
  noUser?: boolean;
  onSelectAll?: () => void;
  onUnselectAll?: () => void;
  isAllSelected?: boolean;
  isSomeSelected?: boolean;
}

export const SpendingListViewV2 = ({
  spendingList,
  emptyMessage,
  isCheckMode,
  noUser,
  onSelectAll,
  onUnselectAll,
  isAllSelected,
  isSomeSelected
}: SpendingListViewProps) => {
  return (
    <div>
      <Table
        emptyMessage={'Aucune dépense'}
        withCheckCase={isCheckMode}
        onSelectAll={onSelectAll}
        onUnselectAll={onUnselectAll}
        isAllSelected={isAllSelected}
        isSomeSelected={isSomeSelected}
        headerTitle={[
          "Description",
          "Créé le",
          "Montant",
          noUser ? undefined : "Utilisateur",
          "Projet",
          "Catégorie",
          "Statut"
        ].filter((item) => item !== undefined) as string[]
      }
        bodyData={spendingList.map((spending) => ({
          id: spending.id,
          onRowClick: spending.onClick,
          onCheck: spending.onCheck,
          isChecked: spending.isChecked,
          data: [
            () => <span title={spending.title}>{limitString(spending.title, 20)}</span>,
            spending.createdDate,
            numberToStingWithSpaces(spending.grossAmmount || 0),
            noUser ? undefined : spending.userFullNameRenderer ? spending.userFullNameRenderer() : spending.userFirstName + " " + spending.userLastName,
            spending.projectNameRenderer ? spending.projectNameRenderer() : limitString(spending.projectName, 20) || "",
            spending.category || "",
            () => (
              <StatusBox
                color={{
                  background: spending.colorStatus?.backgroundColor,
                  text: spending.colorStatus?.color,
                }}
               iconType={ spending.colorStatus?.iconType}
                size={{
                    height: "20px",
                    font: "0.7rem",
                    width: "100px",
                    lineHeight: "0.8rem"
                }}
              >
                {spending.status}
              </StatusBox>
            ),
          ].filter((item) => item !== undefined) as any[],
        }))}
      />
    </div>
  );
};

export function SpendingListView({
  spendingList,
  emptyMessage,
  isCheckMode
}: SpendingListViewProps) {
  if (emptyMessage && spendingList.length === 0) {
    return <EmptyListIcon message={emptyMessage} marginTop={"80px"} />;
  }
  return (
    <ul className="spending-list">
      {spendingList.map((spending, index) => (
        <li className="spending-list-item" key={index}>
          <ListBoxItem
            titleSize="1.1rem"
            headerTitleLeft={spending.createdDate}
            titleLeft={spending.title}
            subTitleLeft={spending.userFirstName + " " + spending.userLastName}
            titleRight={
              "- " + numberToStingWithSpaces(spending.grossAmmount || 0)
            }
            titleLabelRight="FCFA"
            subTitleRight={spending.status}
            pinColor={spending.pinColor}
            withPin={spending.withPin}
            linkTo={
              !isCheckMode ? "/spending/" + spending.id : undefined
            }
            handleClick={isCheckMode ? spending.onCheck : undefined}
            colorSubTitleRight={spending.colorStatus}
            withCheckCase={isCheckMode}
            isChecked={spending.isChecked}
            onCheck={spending.onCheck}
            
          />
        </li>
      ))}
    </ul>
  );
}

export default SpendingListViewV2;

